(function () {
    var root = document.querySelector('.gm4');
    if (!root) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* Catálogo real: productos publicados en la tienda online con inventario.
       Se filtran por las etiquetas de edad que ya usa el equipo y por precio.
       Forma de cada producto: t título, v marca, p precio, h handle, imgs fotos, d descripción,
       vars [ID de variante, nombre, disponible, precio], tags etiquetas normalizadas */
    var AGE_TAGS = {
        '0-12m': ['Bebes y todlers (0-2)', 'Bebés', '0 - 6 meses', '7 - 12 meses'],
        '1-3a': ['Bebes y todlers (0-2)', 'Primera infancia (2-6)', '13 - 18 meses', '13 -18 meses', '19 - 24 meses', '25 - 36 meses'],
        '3-6a': ['Primera infancia (2-6)'],
        '6-12a': ['Niños y niñas (6-12)']
    };
    var AGE_GROUP_TAGS = ['Bebes y todlers (0-2)', 'Primera infancia (2-6)', 'Niños y niñas (6-12)', 'Teens (12-18)', 'Adultos y familiares'];

    /* Género: las etiquetas aún no existen; cuando el equipo las agregue, la máquina ya las usa.
       "Para ella" excluye lo marcado solo para niño, y al revés. Sin etiqueta = para cualquiera. */
    var GENDER_TAGS = { ella: 'Para niña', el: 'Para niño' };

    var catalogPromise = null;

    function norm(s) {
        return String(s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, ' ').trim();
    }

    function esc(s) {
        return String(s).replace(/[&<>"']/g, function (c) {
            return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
        });
    }

    function imgUrl(src, w) {
        if (!src) return '';
        return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
    }

    function plainText(html, max) {
        var div = document.createElement('div');
        div.innerHTML = html || '';
        var text = (div.textContent || '').replace(/\s+/g, ' ').trim();
        return text.length > max ? text.slice(0, max).replace(/\s+\S*$/, '') + '…' : text;
    }

    function loadCatalog() {
        var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        var products = [];
        function page(n) {
            return fetch(base + 'products.json?limit=250&page=' + n)
                .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
                .then(function (data) {
                    var list = data.products || [];
                    products = products.concat(list);
                    return list.length === 250 && n < 20 ? page(n + 1) : products;
                });
        }
        return page(1).then(function (list) {
            return list.map(function (p) {
                var vars = (p.variants || []).map(function (v) {
                    return [v.id, v.title === 'Default Title' ? '' : v.title, v.available, parseFloat(v.price)];
                });
                var available = vars.filter(function (v) { return v[2]; });
                if (!available.length) return null;
                return {
                    t: p.title,
                    v: p.vendor,
                    p: Math.min.apply(null, available.map(function (v) { return v[3]; })),
                    h: p.handle,
                    imgs: (p.images || []).map(function (im) { return im.src; }),
                    d: plainText(p.body_html, 260),
                    vars: vars,
                    tags: (p.tags || []).map(norm)
                };
            }).filter(Boolean);
        });
    }

    function hasAny(product, tags) {
        return tags.some(function (t) { return product.tags.indexOf(norm(t)) !== -1; });
    }

    /* Un juguete marcado solo para esta edad va antes que uno marcado para todas las edades */
    function ageSpread(product) {
        return AGE_GROUP_TAGS.filter(function (t) { return product.tags.indexOf(norm(t)) !== -1; }).length;
    }

    var BUDGETS = { '300-500': [300, 500], '500-900': [500, 900], '900+': [900, Infinity] };
    var KEYS = ['age', 'gender', 'budget', 'occasion'];
    var SHAPES = ['circle', 'square', 'triangle', 'rect'];
    var LABELS = { age: 'Edad', gender: 'Para quién', budget: 'Presupuesto', occasion: 'Ocasión' };

    var state = {};
    var labels = {};
    var current = 0;
    var started = false;
    var resultsOffset = 0;
    var pool = [];
    var shown = [];
    var detailIdx = 0;
    var detailVar = null;

    var STORE = 'https://didactijuegos.com';
    var FREE_SHIP = 1699;
    var inShopify = Boolean(window.Shopify && window.Shopify.routes);
    var cart = { items: [], count: 0, total: 0 };

    /* Klaviyo (ya instalado en la tienda, cuenta VKtJJH). LIST_ID es la lista "Máquina de regalos"
       que hay que crear en Klaviyo; mientras diga PENDIENTE, la maqueta simula el registro. */
    var KLAVIYO = { company: 'VKtJJH', list: 'PENDIENTE' };
    var ASK_EMAIL = true;
    var emailKnown = false;
    try { emailKnown = localStorage.getItem('dj_gm_email') === '1'; } catch (e) {}

    /* Medición para retargeting. En Shopify, los eventos se publican con Shopify.analytics.publish
       y un píxel personalizado (Configuración > Eventos de clientes) los reenvía a Meta y Google. */
    var FB_NAMES = { view_item: 'ViewContent', add_to_cart: 'AddToCart', begin_checkout: 'InitiateCheckout' };
    function track(name, data) {
        data = data || {};
        try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('gift_machine_' + name, data); } catch (e) {}
        try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: 'gift_machine_' + name }, data)); } catch (e) {}
        try { if (window.gtag) gtag('event', name, data); } catch (e) {}
        try { if (window.klaviyo && name !== 'lead') klaviyo.track('Máquina de regalos: ' + name, data); } catch (e) {}
        try {
            if (window.fbq) {
                if (FB_NAMES[name]) fbq('track', FB_NAMES[name], { content_ids: data.ids, content_type: 'product', value: data.value, currency: 'MXN' });
                else fbq('trackCustom', 'GiftMachine_' + name, data);
            }
        } catch (e) {}
    }

    var stage = document.getElementById('gm4-stage');
    var tickets = document.getElementById('gm4-tickets');
    var screens = Array.prototype.slice.call(root.querySelectorAll('.screen'));
    var stepItems = Array.prototype.slice.call(document.querySelectorAll('#gm4-stepper li'));
    var backBtn = document.getElementById('gm4-backBtn');

    function screenByName(name) {
        return screens.filter(function (s) { return s.dataset.screen === String(name); })[0];
    }

    function answered() {
        return KEYS.filter(function (k) { return state[k]; }).length;
    }

    function updateStage() {
        stage.style.setProperty('--drop', (answered() / KEYS.length).toFixed(2));
    }

    /* Cables entre el escenario y el panel */
    var grid = document.getElementById('gm4-machine');
    var panel = root.querySelector('.panel');
    var cables = document.getElementById('gm4-cables');
    var pulses = [];

    function drawCables() {
        var g = grid.getBoundingClientRect(), s = stage.getBoundingClientRect(), p = panel.getBoundingClientRect();
        var stacked = p.top >= s.bottom - 2;
        cables.setAttribute('viewBox', '0 0 ' + g.width + ' ' + g.height);
        var html = '';
        pulses = [];
        [0, 1].forEach(function (i) {
            var x1, y1, x2, y2, d;
            if (!stacked) {
                x1 = p.left - g.left + 10; y1 = p.top - g.top + p.height * (i ? 0.58 : 0.2);
                x2 = s.right - g.left - 10; y2 = s.top - g.top + s.height * (i ? 0.64 : 0.26);
                var dx = (x1 - x2) * 0.55, sag = 34 + i * 10;
                d = 'M' + x1 + ' ' + y1 + ' C' + (x1 - dx) + ' ' + (y1 + sag) + ' ' + (x2 + dx) + ' ' + (y2 + sag) + ' ' + x2 + ' ' + y2;
            } else {
                x1 = p.left - g.left + p.width * (i ? 0.7 : 0.3); y1 = p.top - g.top + 10;
                x2 = s.left - g.left + s.width * (i ? 0.66 : 0.34); y2 = s.bottom - g.top - 10;
                var dy = (y1 - y2) * 0.7;
                d = 'M' + x1 + ' ' + y1 + ' C' + x1 + ' ' + (y1 - dy) + ' ' + x2 + ' ' + (y2 + dy) + ' ' + x2 + ' ' + y2;
            }
            html += '<path class="cable-base" d="' + d + '"/><path class="cable-rib" d="' + d + '"/><path class="cable-hi" d="' + d + '"/><path class="cable-pulse" d="' + d + '"/>' +
                '<circle class="plug" cx="' + x1 + '" cy="' + y1 + '" r="12"/><circle class="plug-core" cx="' + x1 + '" cy="' + y1 + '" r="5"/>' +
                '<circle class="plug" cx="' + x2 + '" cy="' + y2 + '" r="12"/><circle class="plug-core" cx="' + x2 + '" cy="' + y2 + '" r="5"/>';
        });
        cables.innerHTML = html;
        pulses = Array.prototype.slice.call(cables.querySelectorAll('.cable-pulse'));
    }

    /* Un pulso viaja del panel a la máquina cuando eliges una respuesta */
    function pulse() {
        if (reduceMotion) return;
        pulses.forEach(function (path, i) {
            var len = path.getTotalLength();
            path.style.strokeDasharray = '46 ' + len;
            path.style.opacity = 1;
            path.animate([{ strokeDashoffset: 46 }, { strokeDashoffset: -len }], { duration: 620, delay: i * 60, easing: 'cubic-bezier(0.4, 0, 0.6, 1)' })
                .onfinish = function () { path.style.opacity = 0; };
        });
    }

    /* Alto disponible bajo el encabezado del tema, para que el bloque no rebase la pantalla */
    function fitToViewport() {
        var top = grid.getBoundingClientRect().top + window.scrollY;
        root.style.setProperty('--fit', Math.round(window.innerHeight - top - 24) + 'px');
    }

    function layout() {
        fitToViewport();
        drawCables();
    }

    layout();
    window.addEventListener('resize', layout);
    window.addEventListener('load', layout);
    if ('ResizeObserver' in window) new ResizeObserver(drawCables).observe(panel);

    function renderTickets() {
        tickets.innerHTML = '';
        KEYS.forEach(function (key, i) {
            if (!state[key]) return;
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'ticket';
            b.setAttribute('aria-label', 'Cambiar ' + LABELS[key].toLowerCase() + ': ' + labels[key]);
            b.innerHTML = '<i class="shape shape-' + SHAPES[i] + '" aria-hidden="true"></i><small>' + LABELS[key] + '</small>' + labels[key];
            b.addEventListener('click', function () { show(i, true); });
            tickets.appendChild(b);
        });
    }

    function updateStepper() {
        stepItems.forEach(function (li, i) {
            li.classList.toggle('is-current', typeof current === 'number' && i === current);
            li.classList.toggle('is-done', Boolean(state[KEYS[i]]) && i !== current);
        });
        backBtn.disabled = current === 0 || current === 'loading';
    }

    /* Resultados con aire si caben en el alto de la máquina; si no, versión compacta */
    function fitResults() {
        if (current !== 'results') return;
        panel.classList.add('is-roomy');
        if (window.innerWidth <= 1024) return;
        if (panel.getBoundingClientRect().height > stage.getBoundingClientRect().height + 1) panel.classList.remove('is-roomy');
    }

    window.addEventListener('resize', fitResults);

    function show(target, back) {
        var prev = screenByName(current);
        var next = screenByName(target);
        if (prev) prev.classList.remove('is-active', 'from-back');
        next.classList.toggle('from-back', Boolean(back));
        next.classList.add('is-active');
        current = target;
        updateStepper();
        stage.classList.toggle('is-done', target === 'results' || target === 'detail');
        if (target !== 'results' && typeof gateOverlay !== 'undefined' && gateOverlay) closeGate(false);
        panel.classList.toggle('is-results', target === 'results');
        panel.classList.toggle('is-detail', target === 'detail');
        stage.classList.toggle('is-searching', target === 'loading');
        if (target === 'results') {
            stage.style.setProperty('--drop', '1.12');
            fitResults();
        }
        else if (target !== 'loading') updateStage();
        var heading = next.querySelector('h2');
        if (heading) {
            heading.setAttribute('tabindex', '-1');
            heading.focus({ preventScroll: true });
        }
        if (window.innerWidth <= 1024 && started) {
            var top = grid.getBoundingClientRect().top + window.scrollY - 6;
            window.scrollTo({ top: top, behavior: reduceMotion ? 'auto' : 'smooth' });
        }
        started = true;
    }

    /* Opciones */
    root.querySelectorAll('.opt').forEach(function (opt) {
        opt.addEventListener('click', function () {
            var key = opt.dataset.key;
            var group = opt.closest('.options');
            group.querySelectorAll('.opt').forEach(function (o) { o.classList.remove('is-selected'); });
            opt.classList.add('is-selected');
            if (!answered()) track('start', { step: key });
            if (!catalogPromise) catalogPromise = loadCatalog();
            state[key] = opt.dataset.value;
            labels[key] = opt.dataset.label;
            pulse();
            setTimeout(renderTickets, reduceMotion ? 0 : 520);
            updateStage();

            var idx = KEYS.indexOf(key);
            var pending = KEYS.findIndex(function (k) { return !state[k]; });
            setTimeout(function () {
                if (pending === -1) search();
                else show(pending > idx ? idx + 1 : pending);
            }, reduceMotion ? 0 : 380);
        });
    });

    /* Stepper y atrás */
    root.querySelectorAll('.step-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
            var i = parseInt(btn.dataset.step, 10);
            if (state[KEYS[i]] && current !== 'loading') show(i, true);
        });
    });

    backBtn.addEventListener('click', function () {
        if (current === 'detail') show('results', true);
        else if (current === 'gate') show(3, true);
        else if (current === 'results') show(3, true);
        else if (typeof current === 'number' && current > 0) show(current - 1, true);
    });

    /* Búsqueda */
    function buildPool(catalog) {
        var range = BUDGETS[state.budget];
        var byAge = catalog.filter(function (p) { return hasAny(p, AGE_TAGS[state.age]); });

        var wanted = GENDER_TAGS[state.gender];
        if (wanted) {
            var other = state.gender === 'ella' ? GENDER_TAGS.el : GENDER_TAGS.ella;
            byAge = byAge.filter(function (p) { return !hasAny(p, [other]) || hasAny(p, [wanted]); });
        }

        function rank(a, b) {
            var ia = a.imgs.length ? 0 : 1, ib = b.imgs.length ? 0 : 1;
            var ga = wanted && hasAny(a, [wanted]) ? 0 : 1, gb = wanted && hasAny(b, [wanted]) ? 0 : 1;
            return (ia - ib) || (ga - gb) || (ageSpread(a) - ageSpread(b));
        }

        var inBudget = byAge.filter(function (p) { return p.p >= range[0] && p.p <= range[1]; }).sort(rank);
        var edge = range[1] === Infinity ? range[0] : range[1];
        var rest = byAge.filter(function (p) { return inBudget.indexOf(p) === -1; })
            .sort(function (a, b) {
                if (!a.imgs.length !== !b.imgs.length) return a.imgs.length ? -1 : 1;
                var da = Math.min(Math.abs(a.p - range[0]), Math.abs(a.p - edge));
                var db = Math.min(Math.abs(b.p - range[0]), Math.abs(b.p - edge));
                return da - db;
            });
        return inBudget.concat(rest);
    }

    function search() {
        show('loading');
        if (!catalogPromise) catalogPromise = loadCatalog();
        var msgs = ['Revisando la edad…', 'Ajustando el presupuesto…', 'Eligiendo los mejores…'];
        var msg = document.getElementById('gm4-loadingMsg');
        var i = 0;
        msg.textContent = msgs[0];
        var animation = new Promise(function (resolve) {
            var timer = setInterval(function () {
                i++;
                if (i < msgs.length) {
                    msg.style.opacity = 0;
                    setTimeout(function () { msg.textContent = msgs[i]; msg.style.opacity = 1; }, 250);
                } else {
                    clearInterval(timer);
                    resolve();
                }
            }, reduceMotion ? 10 : 750);
        });

        Promise.all([catalogPromise, animation]).then(function (res) {
            pool = buildPool(res[0]);
        }).catch(function (err) {
            console.error('Máquina de regalos: no se pudo cargar el catálogo', err);
            catalogPromise = null;
            pool = [];
        }).then(function () {
            resultsOffset = 0;
            renderResults();
            paintGate();
            show('results');
            track('complete', { age: state.age, gender: state.gender, budget: state.budget, occasion: state.occasion, results: pool.length });
        });
    }

    function money(n) {
        return '<sup>$</sup>' + n.toLocaleString('es-MX');
    }

    function renderResults() {
        var list = document.getElementById('gm4-results');
        var title = document.getElementById('gm4-resTitle');
        var sub = document.getElementById('gm4-resSub');
        var more = document.getElementById('gm4-moreBtn');
        list.innerHTML = '';

        if (!pool.length) {
            title.innerHTML = 'No encontramos regalos <span>con esta combinación</span>';
            sub.textContent = 'Prueba con otro presupuesto u otra edad.';
            more.hidden = true;
            document.getElementById('gm4-shareBtn').parentNode.hidden = true;
            return;
        }

        var items = [];
        for (var i = 0; i < 3 && i < pool.length; i++) items.push(pool[(resultsOffset + i) % pool.length]);

        title.innerHTML = items.length + ' regalo' + (items.length > 1 ? 's' : '') + ' para <span>' + labels.age + '</span>';
        sub.textContent = labels.gender + ' · ' + labels.budget + ' · ' + labels.occasion;
        more.hidden = pool.length <= 3;

        shown = items;
        paintShare();
        setTimeout(fitResults, 0);
        items.forEach(function (p, i) {
            var li = document.createElement('li');
            li.className = 'r-card' + (inCart(p) ? ' in-cart' : '');
            li.style.setProperty('--d', (i * 0.08) + 's');
            li.innerHTML =
                '<span class="r-img" aria-hidden="true"><img src="' + imgUrl(p.imgs[0], 400) + '\" alt="" /></span>' +
                '<div><div class="r-vendor">' + esc(p.v) + '<span class="r-added">En tu carrito</span></div><h3 class="r-title">' + p.t + '</h3><div class="r-price">' + money(p.p) + '</div></div>' +
                '<button class="btn btn-dark btn-sm" type="button" aria-label="Ver ' + esc(p.t) + '"><span class="btn-txt">Ver regalo</span> <span class="arr" aria-hidden="true">→</span></button>';
            li.addEventListener('click', function () { openDetail(i); });
            list.appendChild(li);
        });
    }

    /* Detalle del regalo dentro de la máquina */
    var dImg = document.getElementById('gm4-dImg');
    var addBtn = document.getElementById('gm4-addBtn');

    function inCart(p) {
        return cart.items.some(function (it) { return p.vars.some(function (v) { return v[0] === it.id; }); });
    }

    function openDetail(i) {
        detailIdx = (i + shown.length) % shown.length;
        var p = shown[detailIdx];
        document.getElementById('gm4-dPos').textContent = (detailIdx + 1) + ' de ' + shown.length;
        document.getElementById('gm4-dVendor').textContent = p.v;
        document.getElementById('gm4-dTitle').textContent = p.t;
        document.getElementById('gm4-dDesc').textContent = p.d;
        document.getElementById('gm4-fullLink').href = STORE + '/products/' + p.h;
        setPhoto(p, 0);

        var thumbs = document.getElementById('gm4-dThumbs');
        thumbs.innerHTML = '';
        if (p.imgs.length > 1) p.imgs.forEach(function (src, k) {
            var b = document.createElement('button');
            b.type = 'button';
            b.setAttribute('aria-label', 'Foto ' + (k + 1));
            b.innerHTML = '<img src="' + imgUrl(src, 120) + '\" alt="" />';
            b.addEventListener('click', function () { setPhoto(p, k); });
            thumbs.appendChild(b);
        });
        markThumb(0);

        /* Variantes: solo se muestran cuando hay más de una */
        var box = document.getElementById('gm4-dVariants');
        var chips = document.getElementById('gm4-dChips');
        chips.innerHTML = '';
        detailVar = p.vars.filter(function (v) { return v[2]; })[0];
        box.hidden = p.vars.length < 2;
        p.vars.forEach(function (v) {
            if (p.vars.length < 2) return;
            var c = document.createElement('button');
            c.type = 'button';
            c.textContent = v[1];
            c.disabled = !v[2];
            if (!v[2]) c.title = 'Agotado';
            c.addEventListener('click', function () { detailVar = v; paintVariant(p); });
            c._v = v;
            chips.appendChild(c);
        });
        paintVariant(p);

        if (current !== 'detail') show('detail');
        track('view_item', { ids: [detailVar[0]], name: p.t, value: detailVar[3], currency: 'MXN' });
    }

    function setPhoto(p, k) {
        dImg.src = imgUrl(p.imgs[k], 700);
        dImg.alt = p.t;
        markThumb(k);
    }

    function markThumb(k) {
        Array.prototype.forEach.call(document.getElementById('gm4-dThumbs').children, function (b, j) {
            b.classList.toggle('is-on', j === k);
        });
    }

    function paintVariant(p) {
        Array.prototype.forEach.call(document.getElementById('gm4-dChips').children, function (c) {
            c.classList.toggle('is-on', c._v === detailVar);
        });
        document.getElementById('gm4-dPrice').innerHTML = money(detailVar[3]);
        var added = cart.items.some(function (it) { return it.id === detailVar[0]; });
        addBtn.classList.toggle('is-added', added);
        addBtn.querySelector('.btn-txt').textContent = added ? 'En tu carrito, agregar otro' : 'Agregar al carrito';
    }

    /* Ficha completa en popup: carga la ficha premium real (plantilla product.ficha-maquina,
       sin encabezado ni pie) para que no salgan de la máquina. Shopify no permite iframes.
       El "Agregar al carrito" de la ficha lo maneja la máquina: así no las manda a /cart. */
    var ficha = null;
    var fichaReturnFocus = null;

    function buildFicha() {
        ficha = document.createElement('div');
        ficha.className = 'gm4-ficha';
        ficha.hidden = true;
        ficha.setAttribute('role', 'dialog');
        ficha.setAttribute('aria-modal', 'true');
        ficha.setAttribute('aria-label', 'Ficha del producto');
        ficha.innerHTML = '<div class="gm4-ficha-box"><button class="gm4-ficha-close" type="button" aria-label="Cerrar ficha">&times;</button><div class="gm4-ficha-body"></div></div>';
        document.body.appendChild(ficha);

        ficha.querySelector('.gm4-ficha-close').addEventListener('click', closeFicha);
        ficha.addEventListener('click', function (e) { if (e.target === ficha) closeFicha(); });
        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && ficha && !ficha.hidden) closeFicha();
        });

        /* Se detiene aquí para que el código de la ficha no agregue dos veces ni redirija a /cart */
        ficha.addEventListener('submit', function (e) {
            var form = e.target;
            if (!form.matches('form[action*="/cart/add"]')) return;
            e.preventDefault();
            e.stopPropagation();
            var btn = form.querySelector('[type="submit"]');
            var label = btn ? btn.innerHTML : '';
            if (btn) btn.disabled = true;
            fetch(Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: { Accept: 'application/json' },
                body: new FormData(form)
            }).then(function (r) {
                if (!r.ok) throw new Error('HTTP ' + r.status);
                return r.json();
            }).then(function (item) {
                track('add_to_cart', { ids: [item.variant_id], name: item.product_title, value: item.final_price / 100, currency: 'MXN', source: 'ficha' });
                return loadCart();
            }).then(function () {
                paintCart();
                if (current === 'detail') paintVariant(shown[detailIdx]);
                if (btn) { btn.disabled = false; btn.innerHTML = label; }
                closeFicha();
                openThemeCart();
            }).catch(function () {
                if (btn) { btn.disabled = false; btn.textContent = 'Sin inventario suficiente'; setTimeout(function () { btn.innerHTML = label; }, 1800); }
            });
        }, true);
    }

    function runScripts(container) {
        container.querySelectorAll('script').forEach(function (old) {
            if (old.type && old.type !== 'text/javascript' && old.type !== 'module') return;
            var s = document.createElement('script');
            if (old.src) s.src = old.src;
            else s.textContent = old.textContent;
            old.replaceWith(s);
        });
    }

    function openFicha(p) {
        if (!ficha) buildFicha();
        fichaReturnFocus = document.activeElement;
        var bodyEl = ficha.querySelector('.gm4-ficha-body');
        bodyEl.innerHTML = '<p class="gm4-ficha-loading">Cargando la ficha…</p>';
        ficha.hidden = false;
        document.documentElement.classList.add('gm4-locked');
        requestAnimationFrame(function () { ficha.classList.add('is-open'); });
        ficha.querySelector('.gm4-ficha-close').focus({ preventScroll: true });
        track('view_full_item', { name: p.t, handle: p.h });

        fetch(Shopify.routes.root + 'products/' + p.h + '?view=ficha-maquina')
            .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
            .then(function (html) {
                bodyEl.innerHTML = html;
                runScripts(bodyEl);
                ficha.querySelector('.gm4-ficha-box').scrollTop = 0;
            })
            .catch(function () {
                bodyEl.innerHTML = '<p class="gm4-ficha-loading">No pudimos cargar la ficha. <a href="/products/' + p.h + '">Ábrela aquí</a>.</p>';
            });
    }

    function closeFicha() {
        if (!ficha || ficha.hidden) return;
        ficha.classList.remove('is-open');
        document.documentElement.classList.remove('gm4-locked');
        setTimeout(function () {
            ficha.hidden = true;
            ficha.querySelector('.gm4-ficha-body').innerHTML = '';
        }, reduceMotion ? 0 : 300);
        if (fichaReturnFocus && fichaReturnFocus.focus) fichaReturnFocus.focus({ preventScroll: true });
    }

    document.getElementById('gm4-fullLink').addEventListener('click', function (e) {
        if (!inShopify) return;
        e.preventDefault();
        openFicha(shown[detailIdx]);
    });

    document.getElementById('gm4-prevBtn').addEventListener('click', function () { openDetail(detailIdx - 1); });
    document.getElementById('gm4-nextBtn').addEventListener('click', function () { openDetail(detailIdx + 1); });
    document.getElementById('gm4-toResultsBtn').addEventListener('click', function () { renderResults(); show('results', true); });
    document.getElementById('gm4-keepBtn').addEventListener('click', function () { renderResults(); show('results', true); });

    /* Carrito: en Shopify usa la API del carrito; en la maqueta lo simula y "Ir a pagar"
       arma un enlace de carrito real de didactijuegos.com con las variantes elegidas. */
    addBtn.addEventListener('click', function () {
        var p = shown[detailIdx], v = detailVar;
        if (!v) return;
        addBtn.disabled = true;
        var done = function () {
            addBtn.disabled = false;
            paintVariant(p);
            paintCart();
            pulse();
            stage.classList.remove('is-added');
            void stage.offsetWidth;
            stage.classList.add('is-added');
            track('add_to_cart', { ids: [v[0]], name: p.t, value: v[3], currency: 'MXN' });
            openThemeCart();
        };
        if (inShopify) {
            fetch(Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: [{ id: v[0], quantity: 1 }] })
            }).then(function () { return loadCart(); }).then(done).catch(function () { addBtn.disabled = false; });
        } else {
            var it = cart.items.filter(function (x) { return x.id === v[0]; })[0];
            if (it) it.qty++;
            else cart.items.push({ id: v[0], qty: 1, price: v[3] });
            cart.count = cart.items.reduce(function (s, x) { return s + x.qty; }, 0);
            cart.total = cart.items.reduce(function (s, x) { return s + x.qty * x.price; }, 0);
            setTimeout(done, 350);
        }
    });

    function loadCart() {
        return fetch(Shopify.routes.root + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
            cart.items = c.items.map(function (x) { return { id: x.variant_id, qty: x.quantity, price: x.final_price / 100 }; });
            cart.count = c.item_count;
            cart.total = c.total_price / 100;
            /* Actualiza la burbuja del carrito del tema si existe */
            document.querySelectorAll('[data-cart-count], .cart-count-bubble span').forEach(function (el) { el.textContent = c.item_count; });
        });
    }

    function openThemeCart() {
        if (typeof window.openCart === 'function') window.openCart();
    }

    function paintCart() {
        if (typeof window.openCart === 'function') {
            panel.classList.remove('has-cart');
            return;
        }
        panel.classList.toggle('has-cart', cart.count > 0);
        if (!cart.count) return;
        document.getElementById('gm4-cartCount').innerHTML =
            cart.count + (cart.count === 1 ? ' regalo' : ' regalos') + '<span class="cc-long"> en tu carrito</span> · $' + cart.total.toLocaleString('es-MX');
        var left = FREE_SHIP - cart.total;
        document.getElementById('gm4-cartShip').innerHTML = left > 0
            ? 'Te faltan <b>$' + left.toLocaleString('es-MX') + '</b> para envío gratis'
            : '<b>Ya tienes envío gratis</b>';
        document.getElementById('gm4-cartMeter').style.width = Math.min(100, cart.total / FREE_SHIP * 100) + '%';
        document.getElementById('gm4-checkoutBtn').href = inShopify
            ? Shopify.routes.root + 'checkout'
            : STORE + '/cart/' + cart.items.map(function (x) { return x.id + ':' + x.qty; }).join(',');
    }

    document.getElementById('gm4-checkoutBtn').addEventListener('click', function () {
        track('begin_checkout', { ids: cart.items.map(function (x) { return x.id; }), value: cart.total, currency: 'MXN' });
    });

    if (inShopify) loadCart().then(paintCart);

    /* Correo antes de los resultados */
    var gateForm = document.getElementById('gm4-gateForm');
    var gateEmail = document.getElementById('gm4-gateEmail');
    var gateError = document.getElementById('gm4-gateError');
    var gateBtn = document.getElementById('gm4-gateBtn');

    /* Minipopup de correo: los regalos se ven primero y al segundo aparece encima la oferta.
       Se puede cerrar; si lo cierran no vuelve a salir en esta visita. */
    var gateOverlay = document.getElementById('gm4-gateOverlay');
    var gateTimer = null;
    var gateDismissed = false;
    try { gateDismissed = sessionStorage.getItem('dj_gm_email_skip') === '1'; } catch (e) {}
    var gateReturnFocus = null;

    function paintGate() {
        clearTimeout(gateTimer);
        if (!ASK_EMAIL || emailKnown || gateDismissed || !pool.length) return;
        gateTimer = setTimeout(function () {
            if (current === 'results') openGate();
        }, reduceMotion ? 300 : 1000);
    }

    function openGate() {
        gateReturnFocus = document.activeElement;
        gateOverlay.hidden = false;
        requestAnimationFrame(function () { gateOverlay.classList.add('is-open'); });
        setTimeout(function () { gateEmail.focus({ preventScroll: true }); }, 350);
        track('email_offer_view', {});
    }

    function closeGate(skipped) {
        clearTimeout(gateTimer);
        if (gateOverlay.hidden) return;
        gateOverlay.classList.remove('is-open');
        setTimeout(function () { gateOverlay.hidden = true; }, reduceMotion ? 0 : 300);
        if (skipped) {
            gateDismissed = true;
            try { sessionStorage.setItem('dj_gm_email_skip', '1'); } catch (e) {}
            track('email_offer_skip', {});
        }
        if (gateReturnFocus && gateReturnFocus.focus) gateReturnFocus.focus({ preventScroll: true });
    }

    document.getElementById('gm4-gateClose').addEventListener('click', function () { closeGate(true); });
    document.getElementById('gm4-gateSkip').addEventListener('click', function () { closeGate(true); });
    gateOverlay.addEventListener('click', function (e) { if (e.target === gateOverlay) closeGate(true); });
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !gateOverlay.hidden) closeGate(true);
    });

    function validEmail(v) {
        return /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(v);
    }

    gateEmail.addEventListener('input', function () {
        gateEmail.classList.remove('is-bad');
        gateError.textContent = '';
    });

    gateForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = gateEmail.value.trim();
        if (!validEmail(email)) {
            gateEmail.classList.add('is-bad');
            gateError.textContent = 'Revisa tu correo, parece que le falta algo.';
            gateEmail.focus();
            return;
        }
        gateBtn.disabled = true;
        subscribe(email).then(function () {
            emailKnown = true;
            try { localStorage.setItem('dj_gm_email', '1'); } catch (err) {}
            var sent = document.getElementById('gm4-gateSent');
            sent.textContent = 'Listo. Te mandamos la lista y tu código de 10% a ' + email + '.';
            sent.hidden = false;
            gateBtn.disabled = false;
            closeGate(false);
            track('lead', { source: 'maquina-de-regalos' });
        }).catch(function () {
            gateBtn.disabled = false;
            gateError.textContent = 'No pudimos registrarte. Intenta de nuevo en un momento.';
        });
    });

    /* Alta en Klaviyo con las respuestas y los regalos recomendados como propiedades del perfil,
       para que el correo de bienvenida muestre esos mismos regalos y lleve el código único. */
    function subscribe(email) {
        var props = {
            gm_edad: state.age, gm_para: state.gender, gm_presupuesto: state.budget, gm_ocasion: state.occasion
        };
        shown.forEach(function (p, i) {
            var n = i + 1;
            props['gm_regalo_' + n + '_titulo'] = p.t;
            props['gm_regalo_' + n + '_precio'] = p.p;
            props['gm_regalo_' + n + '_url'] = STORE + '/products/' + p.h;
            props['gm_regalo_' + n + '_imagen'] = imgUrl(p.imgs[0], 600);
        });
        if (KLAVIYO.list === 'PENDIENTE') return new Promise(function (r) { setTimeout(r, 600); });
        return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO.company, {
            method: 'POST',
            headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' },
            body: JSON.stringify({
                data: {
                    type: 'subscription',
                    attributes: {
                        custom_source: 'Máquina de regalos',
                        profile: { data: { type: 'profile', attributes: { email: email, properties: props } } }
                    },
                    relationships: { list: { data: { type: 'list', id: KLAVIYO.list } } }
                }
            })
        }).then(function (r) {
            if (!r.ok) throw new Error(r.status);
            try { if (window.klaviyo) klaviyo.identify({ email: email }); } catch (err) {}
        });
    }


    document.getElementById('gm4-moreBtn').addEventListener('click', function () {
        resultsOffset = (resultsOffset + 3) % pool.length;
        renderResults();
        track('more_results', {});
    });

    document.getElementById('gm4-editBtn').addEventListener('click', function () { show(0, true); });

    /* Compartir la lista por WhatsApp (por ejemplo, para que la pareja elija).
       Los enlaces llevan UTM para medir las visitas que llegan por lo compartido. */
    var SHARE_UTM = 'utm_source=whatsapp&utm_campaign=maquina';

    function shareText() {
        var lines = ['Encontré estos regalos para ' + labels.age + ' en Didactijuegos. ¿Cuál te gusta?', ''];
        shown.forEach(function (p, i) {
            lines.push((i + 1) + '. ' + p.t + ' ($' + p.p.toLocaleString('es-MX') + ')');
            lines.push(STORE + '/products/' + p.h + '?' + SHARE_UTM);
            lines.push('');
        });
        lines.push('Los elegí con la Máquina de Regalos: ' + STORE + '/pages/maquina-de-regalos-nueva?' + SHARE_UTM);
        return lines.join('\n');
    }

    function paintShare() {
        var btn = document.getElementById('gm4-shareBtn');
        btn.parentNode.hidden = !shown.length;
        btn.href = 'https://wa.me/?text=' + encodeURIComponent(shareText());
    }

    document.getElementById('gm4-shareBtn').addEventListener('click', function () {
        track('share_whatsapp', { ids: shown.map(function (p) { return p.h; }) });
    });

    document.getElementById('gm4-restartBtn').addEventListener('click', function () {
        state = {};
        labels = {};
        document.getElementById('gm4-gateSent').hidden = true;
        root.querySelectorAll('.opt.is-selected').forEach(function (o) { o.classList.remove('is-selected'); });
        renderTickets();
        show(0, true);
    });

    updateStepper();
})();
